var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`page-loader ${_vm.isLoading ? 'is-open' : ''}`},[_c('div',[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.i18n.oneMomentPlease)+"…")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }